import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { publicJSON, peekPublicJSON } from '../lib/public-catalogue-cache';

export function useCatalogueIdentity() {
  const { pathname } = useLocation();
  const resource = `/catalogue/identity?path=${encodeURIComponent(pathname)}`;
  const [identity, setIdentity] = useState(() => peekPublicJSON(resource) || null);
  useEffect(() => {
    let live = true;
    setIdentity(peekPublicJSON(resource) || null);
    publicJSON(resource)
      .then(data => {
        if (!live) return;
        if (data?.kind === 'alias') window.location.replace(pathname);
        else if (data) setIdentity(data);
      }).catch(() => {});
    return () => { live = false; };
  }, [pathname, resource]);
  return identity;
}